import { CssBaseline, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AppShell, ActiveSubscriptionProvider } from '@/components/app-shell';
import { CompanyDetailsPage } from '@/pages/company-details-page';
import { CompanySearchPage } from '@/pages/company-search-page';
import { CompanyShellPage } from '@/pages/company-shell-page';
import { AddOnsPage } from '@/pages/add-ons-page';
import { ChannelOnboardingPage } from '@/pages/channel-onboarding-page';
import { CreditLinePage } from '@/pages/credit-line-page';
import { PlanPage } from '@/pages/plan-page';
import { AuthenticationGuard, UserProvider } from '@/services/auth';
import { store } from '@/store';
import { theme } from '@/theme';

/**
 * Application root. Composes the global providers (MUI theme, Snackbar,
 * Redux store, BrowserRouter, UserContext, ActiveSubscription) and the
 * authentication guard around the routes. Any unmatched route redirects
 * to `/`.
 */
export const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={5000}
    >
      <ReduxProvider store={store}>
        <BrowserRouter>
          <UserProvider>
            <AuthenticationGuard>
              <ActiveSubscriptionProvider>
                <Routes>
                  <Route element={<AppShell />}>
                    <Route index element={<CompanySearchPage />} />
                    <Route
                      path="company/:companyId"
                      element={<CompanyShellPage />}
                    >
                      <Route index element={<CompanyDetailsPage />} />
                      <Route
                        path="channel-onboarding"
                        element={<ChannelOnboardingPage />}
                      />
                      <Route path="plan" element={<PlanPage />} />
                      <Route path="add-ons" element={<AddOnsPage />} />
                      <Route path="credit-line" element={<CreditLinePage />} />
                    </Route>
                  </Route>
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </ActiveSubscriptionProvider>
            </AuthenticationGuard>
          </UserProvider>
        </BrowserRouter>
      </ReduxProvider>
    </SnackbarProvider>
  </ThemeProvider>
);
